import { Network } from '@/lib/networkConfig';
import { Icons } from '@/components/icons';

export interface NetworkOption {
  label: string;
  value: Network;
  icon: JSX.Element;
}

export const networkOptions: NetworkOption[] = [
  // {
  //   label: "Signet",
  //   value: "signet",
  //   icon: <Icons.networkSignet />,
  // },
  // {
  //   label: "Testnet3",
  //   value: "testnet3",
  //   icon: <Icons.networkTestnet />,
  // },
  {
    label: 'Mutinynet',
    value: 'mutinynet',
    icon: <Icons.networkMutiny />,
  },
  // {
  //   label: "Regtest",
  //   value: "regtest",
  //   icon: <Icons.networkTestnet />,
  // },
];
